import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import AxiosDataWrapper from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataWrapper';
import AxiosDataIsLoaded from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataIsLoaded/AxiosDataIsLoaded';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import { connect } from 'react-redux';
import { ResourceAccess } from '../../../utility/types/ResourceAccess';
import QuoteDetails from '../QuoteDetails/QuoteDetails';
import NoAccessQuoteScreen from './NoAccessQuoteScreen/NoAccessQuoteScreen';
import WrongRoleQuoteScreen from './WrongRoleQuoteScreen/WrongRoleQuoteScreen';
import envConfig from '../../../envConfig';
import RaApiQuoteMapperV1 from '../../../classes/mappers/quotes/RaApiQuoteMapperV1';
import UnexpectedErrorQuoteScreen from './UnexpectedErrorQuoteScreen/UnexpectedErrorQuoteScreen';
import {
  getResourceIdFromURLParam, generateResourceURLFromParam,
} from '../../../utility/orderAndQuoteUtil';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import {
  selectSessionInformation, sessionInformationPropType,
  setSubscriptionSwapRedirectUrl,
} from '../../../redux/slices/sessionSlice';
import dispatchAction from '../../../redux/utils/dispatchAction';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

class QuoteDetailsPage extends Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    this.state = {
      quote: { quoteNumber: `OUO-${id}` },
      loading: true,
      loadError: false,
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatchAction(dispatch,
      setSubscriptionSwapRedirectUrl,
      '/s/orders/quotes/list');
    // this.dispatchAction(setSubscriptionSwapRedirectUrl('/s/orders/quotes/list'));
    this.getData();
  }

  getData() {
    const { match } = this.props;
    const { id } = match.params;
    this.setState({ loading: true });
    RaaAuthenticatedRemoteService.globalInstance()
      .get(
        `${envConfig.apiUrl}/api/v1/quotes/request/${getResourceIdFromURLParam(id)}`,
      )
      .then((quoteResponse) => {
        if (quoteResponse.success === false) {
          this.setState({
            loadError: true,
          });
        }
        const quote = RaApiQuoteMapperV1.mapJsonToQuote(quoteResponse.quoteDetails);
        this.setState({
          quote,
          loading: false,
          accessResponse: quoteResponse.resourceAccess,
          quoteSubscriptionId: quoteResponse.quoteSubscriptionId,
        });
      })
      .catch(() => {
        this.setState({
          loadError: true,
        });
      });
  }

  onCloseError() {
    this.setState({ loadError: false });
  }

  changeSubscriptions(quoteSubscriptionId) {
    const formData = new FormData();
    formData.append('subscriptionId', quoteSubscriptionId);
    RaaAuthenticatedRemoteService.globalInstance().post(`${envConfig.raaUrl}/user/data/select-subscription`, { data: formData })
      .then((response) => {
        if (response === 'OK') {
          window.location.reload();
        } else {
          this.setState({ unexpectedError: true, loading: false });
        }
      }).catch(() => {
        this.setState({ unexpectedError: true, loading: false });
      });
  }

  renderQuote() {
    const {
      match, history, sessionInformation, dispatch,
    } = this.props;
    const { id } = match.params;
    const {
      quote, accessResponse, quoteSubscriptionId, loadError, unexpectedError,
    } = this.state;
    if (unexpectedError) {
      return (<UnexpectedErrorQuoteScreen quote={quote} loadError={loadError} />);
    }

    switch (accessResponse) {
      case ResourceAccess.HAS_ACCESS:
        return (
          <AxiosDataWrapper url="/order/country-list" config={{ dataTitle: 'countryList' }}>
            <AxiosDataIsLoaded>
              <QuoteDetails
                quoteDetails={quote}
                supportsRoles={sessionInformation.activeSubscription.supportsRoles}
                samlEnabled={sessionInformation.activeSubscription.samlEnabled}
                userHasGrantAccessPrivileges={sessionUserHasRolePrivileges(
                  sessionInformation.activeSubscription, [RaaRoles.ADMIN],
                )}
                userHasShareLinkPrivileges={sessionUserHasRolePrivileges(
                  sessionInformation.activeSubscription, [RaaRoles.BILLING],
                )}
                setSubscriptionSwapUrl={
                  (url) => dispatchAction(dispatch, setSubscriptionSwapRedirectUrl, url)
                }
                email={sessionInformation.email}
                validationId={id.split('-')[2]}
              />
            </AxiosDataIsLoaded>
          </AxiosDataWrapper>
        );
      case ResourceAccess.NO_ACCESS:
        return (
          <NoAccessQuoteScreen
            quote={quote}
            loadError={loadError}
            subscriptionId={quoteSubscriptionId}
          />
        );
      case ResourceAccess.INACTIVE_SUB:
        this.setState({ loading: true });
        this.changeSubscriptions(quoteSubscriptionId);
        return (<></>);
      case ResourceAccess.INSUFFICIENT_PRIVILEGE:
        return (<WrongRoleQuoteScreen quote={quote} loadError={loadError} />);
      case ResourceAccess.NOT_AUTHENTICATED:
        history.push(`/p/quote/QUO-${generateResourceURLFromParam(id)}`);
        return (<></>);
      default:
        return (<></>);
    }
  }

  render() {
    const {
      loading, loadError,
    } = this.state;
    return (
      <div className="container-fluid mt-3 overflow-hidden">
        <div className="col-12">
          {loadError && (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={this.onCloseError}>
                  Unexpected Error retrieving quote.
                </ErrorBanner>
              </div>
            </div>
          )}
          {loading ? ((
            <div className="row d-flex justify-content-center mt-5">
              <div>
                <ProgressSpinner />
              </div>
            </div>
          ))
            : (
              <>
                {this.renderQuote()}
              </>
            )}
        </div>
      </div>
    );
  }
}

export { QuoteDetailsPage };

QuoteDetailsPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) })
    .isRequired,
  dispatch: PropTypes.func.isRequired,
  sessionInformation: sessionInformationPropType.isRequired,
};
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
});
export default withRouter(connect(mapStateToProps)(QuoteDetailsPage));
